import AppLayout from '@/layout/AppLayout.vue'
// import Home from '@/view/home/Home.vue'
const CoinStock = () => import('@/view/stock/CoinStock.vue')
const CoinStockConvert = () => import('@/view/stock/CoinStockConvert.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/coinStock',
        component: CoinStock,
        meta: { key: 'coinStock' },
      },
      {
        path: '/coinStockConvert',
        component: CoinStockConvert,
        meta: { key: 'coinStockConvert', header: 'coinStock' },
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
